import { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhoWeHelp from "./components/WhoWeHelp";
import BookCall from "./components/BookCall";
import About from "./components/About";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import WhyChoose from "./components/WhyChoose";
import Benefits from "./components/Benefits";
import WhoWeServe from "./components/WhoWeServe";
import Testimonials from "./components/Testimonials";
import Team from "./components/Team";
import FrequentlyAsk from "./components/FrequentlyAsk";
import Blogs from "./components/Blogs";
import Career from "./components/Career";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PartnershipPhilosophy from "./components/PartnershipPhilosophy";
import ReadyToElevate from "./components/ReadyToElevate";

import AdminLayout from "./components/admin/AdminLayout";
import Login from "./pages/Login";

/* ===============================
   🔐 AUTH HELPER
=============================== */
const getToken = () => localStorage.getItem("token");

function App() {
  const [isCareerPage, setIsCareerPage] = useState(false);
  const [isAdmin, setIsAdmin] = useState(!!getToken());

  /* ===============================
     🔥 SYNC AUTH STATE
  =============================== */
  useEffect(() => {
    const checkAuth = () => {
      const token = getToken();

      console.log("🔐 TOKEN CHECK:", token);

      setIsAdmin(!!token);
    };

    checkAuth();

    window.addEventListener("storage", checkAuth);
    window.addEventListener("focus", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener("focus", checkAuth);
    };
  }, []);

  /* ===============================
     🔐 PROTECTED ROUTE
  =============================== */
  const ProtectedRoute = ({ children }) => {
    return isAdmin ? children : <Navigate to="/login" replace />;
  };

  /* ===============================
     🔐 PUBLIC ROUTE
  =============================== */
  const PublicRoute = ({ children }) => {
    return isAdmin ? <Navigate to="/rcreate/dashboard" replace /> : children;
  };

  return (
    <Router>
      <Routes>

        {/* LOGIN */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* ADMIN DASHBOARD */}
        <Route
          path="/rcreate/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        />

        {/* MAIN SITE */}
        <Route
          path="/*"
          element={
            <div className="relative min-h-screen bg-neutral-background text-primary font-body overflow-x-hidden">

              {/* Glow Background */}
              <div className="pointer-events-none fixed top-[-300px] left-1/2 -translate-x-1/2 w-[900px] h-[900px] bg-accent/5 blur-[220px] rounded-full -z-10" />

              {/* NAVBAR */}
              <Navbar
                onCareerClick={() => {
                  setIsCareerPage(true);
                  window.scrollTo(0, 0);
                }}
                isCareerPage={isCareerPage}
              />

              <main className="relative z-10">
                {!isCareerPage ? (
                  <>
                    <Hero />
                    <WhoWeHelp />
                    <BookCall />
                    <About />
                    <Services />
                    <PartnershipPhilosophy />
                    <HowItWorks />
                    <WhyChoose />
                    <Benefits />
                    <WhoWeServe />
                    <Team />
                    <Testimonials />
                    <FrequentlyAsk />
                    <ReadyToElevate />
                    <Blogs />
                    <Contact />
                  </>
                ) : (
                  <Career />
                )}
              </main>

              <Footer />
            </div>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;